import axios from "axios";
import Cookies from "js-cookie";

const API_ROOT =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

const withAuthHeaders = () => {
  const token = Cookies.get("authToken");
  const officeCode = Cookies.get("officeCodes") || Cookies.get("officeCode");

  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(officeCode ? { "Office-Code": officeCode } : {}),
  };
};

export const tableSavedViewsApi = {
  list: (pageKey) =>
    axios.get(`${API_ROOT}/api/table-saved-views`, {
      params: { pageKey },
      headers: withAuthHeaders(),
    }),

  get: (id) =>
    axios.get(`${API_ROOT}/api/table-saved-views/${id}`, {
      headers: withAuthHeaders(),
    }),

  create: (body) =>
    axios.post(`${API_ROOT}/api/table-saved-views`, body, {
      headers: { "Content-Type": "application/json", ...withAuthHeaders() },
    }),

  update: (id, body) =>
    axios.put(`${API_ROOT}/api/table-saved-views/${id}`, body, {
      headers: { "Content-Type": "application/json", ...withAuthHeaders() },
    }),

  remove: (id) =>
    axios.delete(`${API_ROOT}/api/table-saved-views/${id}`, {
      headers: withAuthHeaders(),
    }),

  setDefault: (id) =>
    axios.patch(`${API_ROOT}/api/table-saved-views/${id}/default`, null, {
      headers: withAuthHeaders(),
    }),

  recordUsed: (id) =>
    axios.patch(`${API_ROOT}/api/table-saved-views/${id}/used`, null, {
      headers: withAuthHeaders(),
    }),
};
